import { Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, SelectInput, required, DateInput, AutocompleteInput, useRedirect, useNotify, RadioButtonGroupInput, FileInput, FileField } from "react-admin";
import { cleanTimeChoices, getNameAndCompanyNamewithAddress } from "../common";
import { useLocation } from "react-router-dom";

const CleanReceptHistoryCreate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = useRedirect();
  const notify = useNotify();
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(searchParams.get("customer"));
  const [isComplete, setIsComplete] = useState(0);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    fetchUser();
  }, []);

  return (
    <>
      {customers &&
        <Create mutationMode="pessimistic"
          mutationOptions={{
            onSuccess: () => {
              notify('作成が完了しました', { type: 'success' });
              window.history.back();
              // redirect('list', 'cleanReceptHistory');
            }
          }}
        >
          <SimpleForm
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          >
            <AutocompleteInput
              source="customerId"
              label="顧客名"
              choices={customers.map(req => ({
                id: req.id,
                name: `${getNameAndCompanyNamewithAddress(req)}`
              }))}
              onChange={(e) => setCustomerId(e)}
              validate={required()}
              defaultValue={customerId}
              allowEmpty
              freeSolo
            />
            <DateInput source="receptDate" label="受付日" inputProps={{ max: '9999-12-31' }} />
            <TextInput source="content" label="受付内容" multiline rows={5} />
            <RadioButtonGroupInput
              source="isComplete"
              label="清掃予定"
              choices={[
                { id: 1, name: '予定済み' },
                { id: 0, name: '未予定' }
              ]}
              defaultValue={isComplete}
              validate={required()}
              onChange={(e) => {
                setIsComplete(Number(e.target.value))
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <DateInput source="exCleaningDate" label="清掃予定日" style={{ marginRight: "10px" }} disabled={!isComplete} inputProps={{ max: '9999-12-31' }} />
              <SelectInput
                source="exCleaningTime"
                label="清掃予定時間"
                choices={cleanTimeChoices}
                style={{ marginLeft: "10px", marginRight: "10px" }}
                disabled={!isComplete}
              />
              <SelectInput
                source="district"
                label="地区を選択"
                choices={[
                  { id: "A地区", name: "A地区" },
                  { id: "B地区", name: "B地区" }
                ]}
                style={{ marginLeft: "10px", marginRight: "10px" }}
                disabled={!isComplete}
              />
              <TextInput source="exPumpingAmount" label="汲取予定量【㎥】" type="number" style={{ marginLeft: "10px" }} disabled={!isComplete} />
            </div>
          </SimpleForm>
        </Create>
      }
    </>
  )

};

export default CleanReceptHistoryCreate;
